import type React from 'react';
import { createContext } from 'react';
import type { Panel } from '@atlassian/preview-panels-api';

export interface NavigationListeners {
	onNavigateNext?: () => void;
	onNavigatePrevious?: () => void;
	onNavigateAway?: (toPanel: Panel) => void;
}

export type JiraPreviewPanelsNavigationContextValue = {
	/**
	 * Returns `true` while the in-flight render was triggered by browser back/forward rather than in-app navigation.
	 * Consumers use it to close the issue preview panel when the user backs out to a URL with no selected issue.
	 * The provider stays URL-agnostic — this is just a navigation-source signal, not the param.
	 */
	getIsBrowserPopstateTriggered: () => boolean;
	setPreviewPanelNavigation: (listeners: NavigationListeners) => void;
	markPreviewPanelClick: () => void;
	markIssuePreviewPanelClick: () => void;
};

export const defaultContext: JiraPreviewPanelsNavigationContextValue = {
	getIsBrowserPopstateTriggered: () => false,
	setPreviewPanelNavigation: () => null,
	markPreviewPanelClick: () => null,
	markIssuePreviewPanelClick: () => null,
};

export const JiraPreviewPanelsNavigationContext: React.Context<JiraPreviewPanelsNavigationContextValue> =
	createContext<JiraPreviewPanelsNavigationContextValue>(defaultContext);
